import { useState } from "react";
import { toast } from "react-toastify";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import authService from "../../services/auth/authService";

export default function ChangePassword() {

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

        oldPassword: "",

        newPassword: "",

        confirmPassword: ""

    });


    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm({

            ...form,

            [name]: value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();


        if (!form.oldPassword.trim()) {

            toast.error("Current password is required.");

            return;

        }


        if (!form.newPassword.trim()) {

            toast.error("New password is required.");

            return;

        }


        if (form.newPassword.length < 6) {

            toast.error(
                "New password must be at least 6 characters."
            );

            return;

        }


        if (!form.confirmPassword.trim()) {

            toast.error("Please confirm your new password.");

            return;

        }


        if (form.newPassword !== form.confirmPassword) {

            toast.error("New passwords do not match.");

            return;

        }


        if (form.oldPassword === form.newPassword) {

            toast.error(
                "New password must be different from old password."
            );

            return;

        }


        try {

            setLoading(true);

            const response = await authService.changePassword({

                oldPassword: form.oldPassword,

                newPassword: form.newPassword

            });


            if (response.success) {

                toast.success(
                    response.message || "Password changed successfully."
                );

                setForm({

                    oldPassword: "",

                    newPassword: "",

                    confirmPassword: ""

                });

            }
            else {

                toast.error(
                    response.message || "Failed to change password."
                );

            }

        }
        catch (error) {

            console.log("Change Password Error:", error);

            toast.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        }
        finally {

            setLoading(false);

        }

    };


    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Change Password</h2>

            </div>


            <div className="card">

                <div className="card-body">

                    <form onSubmit={handleSubmit}>

                        <div className="row g-3">


                            {/* Current Password */}

                            <div className="col-lg-7">

                                <label className="form-label">

                                    Current Password

                                    <span className="text-danger">
                                        *
                                    </span>

                                </label>

                                <input
                                    type="password"
                                    className="form-control"
                                    name="oldPassword"
                                    value={form.oldPassword}
                                    onChange={handleChange}
                                    placeholder="Enter current password"
                                    autoComplete="current-password"
                                />

                            </div>


                            {/* New Password */}

                            <div className="col-lg-6">

                                <label className="form-label">

                                    New Password

                                    <span className="text-danger">
                                        *
                                    </span>

                                </label>

                                <input
                                    type="password"
                                    className="form-control"
                                    name="newPassword"
                                    value={form.newPassword}
                                    onChange={handleChange}
                                    placeholder="Enter new password"
                                    autoComplete="new-password"
                                />

                            </div>


                            {/* Confirm Password */}

                            <div className="col-lg-6">

                                <label className="form-label">

                                    Confirm New Password

                                    <span className="text-danger">
                                        *
                                    </span>

                                </label>

                                <input
                                    type="password"
                                    className="form-control"
                                    name="confirmPassword"
                                    value={form.confirmPassword}
                                    onChange={handleChange}
                                    placeholder="Confirm new password"
                                    autoComplete="new-password"
                                />

                            </div>


                        </div>


                        <hr />


                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >

                            {loading
                                ? "Changing..."
                                : "Change Password"}

                        </button>

                    </form>

                </div>

            </div>

        </AdminLayout>

    );

}